'use client'

import { clsx } from 'clsx'
import { createElement, type FC } from 'react'

import { AdServerBanner } from '../../../ad-server'
import { useDeviceDetectorContext } from '../../../device-detector'
import { useSearchPageIsAdBannerAvailable } from '../../ad-banner/useSearchPageIsAdBannerAvailable'

import { type SearchPageAdBannerProps } from './SearchPageAdBannerTypes'

import styles from './SearchPageAdBanner.module.css'

export const SearchPageAdBanner: FC<SearchPageAdBannerProps> = ({
  bannerClasses,
  bannerTags,
  className,
  dimensions,
  wrapperComponent,
}) => {
  const { isMobile } = useDeviceDetectorContext()
  const size = isMobile ? 'small' : 'large'
  const bannerDimensions = dimensions[size]

  const isAvailable = useSearchPageIsAdBannerAvailable(
    bannerTags,
    bannerDimensions,
  )

  if (!isAvailable) {
    return
  }

  const content = (
    <AdServerBanner
      bannerClasses={bannerClasses}
      bannerTags={bannerTags}
      className={clsx(styles['search-page-ad-banner'], className)}
      dimensions={bannerDimensions}
    />
  )

  return wrapperComponent
    ? createElement(wrapperComponent, { className: 'overflow-hidden' }, content)
    : content
}
